module.exports = __webpack_public_path__ + "static/media/shield-icon.f295b59c.svg";